import { cva } from '@/styled-system/css';

export const progressStepperStepRecipe = cva({
  base: {
    '& > .c11n_progress-stepper__step-inner': {
      display: 'grid',
      position: 'relative',
      cursor: 'default',
      zIndex: '2',
      margin: '0', // Safari
      background: 'none',
      border: 'none',
      padding: '0',
      width: '100%',
    },
    '& > a.c11n_progress-stepper__step-inner': {
      textDecoration: {
        base: 'none',
        _hover: 'underline',
      },
    },
  },
  variants: {
    interactive: {
      true: {
        '& > a': {
          focusOutline: true,
        },
        '_hover': {
          '& > a.c11n_progress-stepper__step-inner': {
            cursor: 'pointer',
          },
        },
      },
      false: {},
    },
    active: {
      true: {},
      false: {},
    },
    alignLabel: {
      center: {},
      left: {},
    },
    orientation: {
      horizontal: {
        'width': 'var(--c11n-step-width)',

        '& > .c11n_progress-stepper__step-inner': {
          alignItems: 'center',
          gridTemplateRows: '{sizes.handle.sm} auto',
          rowGap: 'tight',
        },
      },
      vertical: {
        'width': 'auto',
        'paddingBlockEnd': 'loose',

        '& > .c11n_progress-stepper__step-inner': {
          gridTemplateColumns: '{sizes.handle.sm} auto',
          columnGap: 'tight',
        },
      },
    },
    variant: {
      complete: {},
      incomplete: {},
      critical: {},
      warning: {},
      notStarted: {},
      none: {},
      active: {},
    },
  },
  compoundVariants: [
    {
      orientation: 'vertical',
      alignLabel: ['left', 'center'],
      css: {
        '& > .c11n_progress-stepper__step-inner': {
          alignItems: 'flex-start',
        },
      },
    },
    {
      orientation: 'horizontal',
      alignLabel: 'center',
      css: {
        '& > .c11n_progress-stepper__step-inner': {
          justifyContent: 'center',
        },

        '& .c11n_progress-stepper__dot': {
          justifySelf: 'center',
        },
      },
    },
    {
      orientation: 'horizontal',
      alignLabel: 'left',
      css: {
        '&:nth-child(1)': {
          marginInlineStart: 'calc((var(--c11n-step-width) / 2) - {sizes.indicator.xs})',
        },
        // The last step gets only half the width of the others. This prevents long label
        // text from awkwardly extending too far out. It also allows us to left-align the
        // labels without affecting the stepper width and progress bar positioning.
        '&:is(:last-child)': {
          width: 'calc(var(--c11n-step-width) / 2)',
        },
        '& > .c11n_progress-stepper__step-inner': {
          justifyContent: 'flex-start',
        },
      },
    },
  ],
});
